<div class="eosc-fb-card-plugin" hive-root>
    <div class="eosc-fb-card-plugin__icon">
        <svg hive-svg="end-of-support-contract.svg" [height]="40"></svg>
    </div>

    <p class="hive-paragraph-small hive-paragraph-regular eosc-fb-card-plugin__message">
        The support contract for this appliance is expired
    </p>

    <h3 class="hive-header-semibold eosc-fb-card-plugin__expired">Expired</h3>

    <eosc-renew-call-to-action></eosc-renew-call-to-action>
</div>
